import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import { Circles } from "react-loader-spinner";
import BigAdd from './BigAdd';
import { Helmet } from 'react-helmet';
// import './style1.css';

const BASE_URL = "https://api.shabdtoday.com/";
const image_resize = "https://api.shabdtoday.com/api/home/resize";

const truncateText = (text, maxLength) => {
  if (text.length > maxLength) {
    return text.substring(0, maxLength);
  }
  return text;
};

const stripHtmlTags = (html, maxLength) => {
  const tempDiv = document.createElement("div");
  tempDiv.innerHTML = html;
  const strippedText = tempDiv.textContent || tempDiv.innerText || "";
  return truncateText(strippedText, maxLength);
};
function VideoDetails() {
  const [postData, setPostData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          "https://api.shabdtoday.com/api/home/getvideo"
        );
        setPostData(response.data);
        setLoading(false);
      } catch (error) {
        setError(error.message);
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  const handleNewsClick = (trendingTagId) => {
    navigate(`/NewsDetails/${trendingTagId}`);
  };
  const formatDateInHindi = (dateString) => {
    const date = new Date(dateString);
    const monthsInHindi = [
      "जनवरी",
      "फरवरी",
      "मार्च",
      "अप्रैल",
      "मई",
      "जून",
      "जुलाई",
      "अगस्त",
      "सितंबर",
      "अक्टूबर",
      "नवंबर",
      "दिसंबर",
    ];
    const day = date.getDate();
    const month = monthsInHindi[date.getMonth()];
    const year = date.getFullYear();
    return `${day} ${month} ${year}`;
  };


  // if (loading) {
  //   return (
  //     <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
  //       <Circles
  //         height="30"
  //         width="30"
  //         color="#f7265c"
  //         ariaLabel="circles-loading"
  //         wrapperStyle={{}}
  //         wrapperClass=""
  //         visible={true}
  //       />
  //     </div>
  //   );
  // }


  if (error) {
    return <div>Error: {error}</div>;
  }
  return (
    <div>
      <Helmet>
        <title>वीडियो समाचार – आज की वीडियो ब्रेकिंग न्यूज़ | ShabdToday</title>

        <meta name="title" content="वीडियो समाचार – आज की वीडियो ब्रेकिंग न्यूज़ | ShabdToday" />
        <meta
          name="description"
          content="देश-दुनिया की ताज़ा वीडियो खबरें—ब्रेकिंग वीडियो, एक्सक्लूसिव रिपोर्ट, ग्राउंड कवरेज और लाइव अपडेट हिंदी में देखें।"
        />
        <meta name="keywords" content="वीडियो समाचार, वीडियो न्यूज़, हिंदी वीडियो खबरें, ब्रेकिंग वीडियो" />
        <meta name="robots" content="index, follow" />
        <meta name="author" content="ShabdToday Team" />

        <link rel="canonical" href="https://shabdtoday.com/Video-News" />

        <meta property="og:title" content="वीडियो समाचार – आज की वीडियो ब्रेकिंग न्यूज़ | ShabdToday" />
        <meta
          property="og:description"
          content="सबसे तेज़ वीडियो ब्रेकिंग न्यूज़—ग्राउंड रिपोर्ट, लाइव अपडेट और देश-दुनिया की दृश्य रिपोर्टिंग हिंदी में।"
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://shabdtoday.com/Video-News" />
        <meta property="og:image" content="https://shabdtoday.com/design/images/COVER-PAGE-NEW.webp" />

        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "CollectionPage",
            "name": "वीडियो समाचार – ShabdToday",
            "url": "https://shabdtoday.com/Video-News",
            "description": "वीडियो फॉर्मेट में देश-दुनिया की ताज़ा और ब्रेकिंग खबरें।",
            "publisher": {
              "@type": "Organization",
              "name": "ShabdToday",
              "logo": {
                "@type": "ImageObject",
                "url": "https://shabdtoday.com/design/images/logo-s.webp"
              }
            }
          })}
        </script>

        <h1 style={{ color: 'crimson', marginLeft: 10 }}>वीडियो न्यूज़</h1>
        <h2 style={{ marginLeft: 10, marginTop: 8 }}>देश-दुनिया की ताज़ा वीडियो खबरें</h2>
        <h3 style={{ marginLeft: 10, marginTop: 8 }}>लाइव रिपोर्ट | ग्राउंड कवरेज | ब्रेकिंग वीडियो</h3>
      </Helmet>

      <section className="container" >
        <div className='mt-3'>
          <BigAdd />
        </div>
        <div className="ak-block-header wdgt-hdng ak-block-header-style-5 no-tabs">
          <b className="mb-2">वीडियो-</b>

        </div>

        <ul className="web-stry" id="webStories">
          {postData.slice(0, 30).map((post) => (
            <li key={post.shortVideoId}>
              <Link
                to={`/Video-News/${post.shortVideoId}`}
                title={post.shortVideoTile}
              >
                <span className="ak-module-format-icon format-video">
                  <i className="ak-icon fa fa-play" />
                </span>
                <img
                  src={`${image_resize}?url=${BASE_URL}${post.shortVideoImage}&w=227&h=405&outtype=webp`}
                  alt="sania mirza trendy ethnic suits for traditional look"
                  title={post.shortVideoTile}
                />
                <i className="fa-solid fa-video play-icon"></i>
                <div className="web-stry-cnt">
                  <p>{stripHtmlTags(post.shortVideoTile, 40)}</p>
                </div>
              </Link>
            </li>
          ))}
        </ul>
      </section>

    </div>
  )
}

export default VideoDetails
